import React, { useState } from 'react';
import { Check, Close } from '@mui/icons-material';
import { IconButton, Paper, Popover, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const TextEntryBox = (props) => {
    const theme = useTheme();
    const sx = {
        paper: {
            padding: theme.spacing(1),
            width: 400,
        },
        textField: {
            width: '100%',
        },
    };

    const [value, setValue] = useState('');

    const updateValue = (e) => setValue(e.target.value);

    const submit = () => {
        props.callback({ value });
        props.close();
    };

    return (
        <Popover
            anchorEl={props.anchor}
            anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
            transformOrigin={{ vertical: 'center', horizontal: 'left' }}
            open={true}
        >
            <Paper sx={sx.paper}>
                <TextField
                    type="text"
                    autoFocus
                    label="Custom Text"
                    onChange={updateValue}
                    value={value}
                    multiline
                    sx={{ mr: 1, ...sx.textField }}
                />
                <IconButton onClick={submit} size="large">
                    <Check sx={{ color: 'green' }} />
                </IconButton>

                <IconButton onClick={props.close} size="large">
                    <Close sx={{ color: 'red' }} />
                </IconButton>
            </Paper>
        </Popover>
    );
};

export default TextEntryBox;
